const getAssetsUrl = () => 'https://assets.creditgenie.com';

// eslint-disable-next-line import/prefer-default-export
export { getAssetsUrl };
